import {
  FavoriteGroupSourceEnum,
  getHireCandidatesListInfiniteQueryOptions,
  getHireJobsListQueryOptions,
  getNextPageParam,
  getProGroupsListQueryOptions,
} from "@sidegigllc/api/client";
import type { CandidatesSearch } from "domains/hire/containers/Candidates/routing";
import type { WarmableQuery } from "routing/warmQueries";
import { buildCandidatesListParams } from "./utils";

// `appliedOnly`: Connect's Applicants tab lists only the pros who applied to a job here.
type QueriesInput = { search: CandidatesSearch; appliedOnly?: boolean };

export const candidatesQuery = ({ search, appliedOnly }: QueriesInput) =>
  getHireCandidatesListInfiniteQueryOptions(buildCandidatesListParams(search, { appliedOnly }), {
    query: { getNextPageParam, enabled: search.tab !== "groups" },
  });

// The Job filter's menu: one page of the location's jobs
export const applicantJobsQuery = () => getHireJobsListQueryOptions({ page_size: 100, ordering: "name" });

// Not in `queries`: the organization is derived from the organizations list, which the loader doesn't have.
// `allSources`: the one-kind-of-group flag is on, so Hire lists every group, not just the hired ones.
export const proGroupsQuery = ({
  organizationId,
  marketId,
  allSources,
}: {
  organizationId?: string;
  marketId?: number;
  allSources?: boolean;
}) =>
  getProGroupsListQueryOptions(
    {
      organization_id: organizationId,
      market_id: marketId,
      source: allSources ? undefined : FavoriteGroupSourceEnum.HIRE,
    },
    { query: { enabled: !!organizationId } },
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  candidatesQuery(input),
  ...(input.appliedOnly ? [applicantJobsQuery()] : []),
];
